/**
 * @file phonenumber.class.js
 * @description Defines the PhoneNumber class.
 */

class PhoneNumber {
  constructor(debug = false) {
    this.elPhoneNumbers = Helper.getElements('[data-phone-number]');
    this.init();
    this.debug();
  }

  init() {
    if (this.elPhoneNumbers) {
      this.initPhoneNumbers();
      this.bindEvents();
      this.initialSetup();
    }
  }

  /**
   *  @description Loop through each phone number and initialize the data.
   */
  initPhoneNumbers() {
    this.elPhoneNumbers.forEach( elPhoneNumber => {
      elPhoneNumber.data = {
        phoneNumber: elPhoneNumber.href,
        destination: elPhoneNumber.dataset.destination || '/about-us/contact-us',
        breakpoint: elPhoneNumber.dataset.breakpoint || 768,
        gtag: elPhoneNumber.dataset.gtag || true
      };
    });
  }

  /**
   * @description Bind Resize events to change the href attribute of each phone
   * number. Bind click events to each phone number to call the gtag event.
   */
  bindEvents() {
    this.elPhoneNumbers.forEach( elPhoneNumber => {
      window.addEventListener('resize', () => { this.changeHref(elPhoneNumber); });
      elPhoneNumber.addEventListener('click', () => { this.callGtag(); });
    });
  }

  /**
   * @description Loops through each phone number and sets the href based on the
   * elements data breakpoint.
   */
  initialSetup() {
    this.elPhoneNumbers.forEach( elPhoneNumber => { this.changeHref(elPhoneNumber); });
  }

  /**
   * @description Change the href of the passed element based on the breakpoint
   * defined in the elements data property.
   * @param {Node} elPhoneNumber 
   */
  changeHref(elPhoneNumber) {
    let windowWidth = window.innerWidth;

    if (windowWidth > elPhoneNumber.data.breakpoint) {
      elPhoneNumber.href = elPhoneNumber.data.destination;
    } else {
      elPhoneNumber.href = elPhoneNumber.data.phoneNumber;
    }
  }

  /**
   * @description Calls Google's gtag function for event tracking.
   * @requires gtag Google's event tracking library.
   */
  callGtag() {
    gtag('event', 'Clicked', {event_category: "Phone Call", event_label: "Phone Number"});
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c PhoneNumber', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}